import { useMemo } from 'react';
import { Box, Divider, FullRow, TextButton, useOverlayContext } from 'seagull';
import { Download, UserAddLiner24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { getAgreementPdfUrl } from "../../../../../business-logic/relationshipLogic";
import InviteOrEditMemberModal from "../../../../../components/InviteOrEditMemberModal";
import { useIoContext, useStore } from "../../../../../contexts";
import { relationshipModel } from "../../../../../models";
import { selectors } from "../../../../../store/state-selectors";
import styles from "./CoverPageHeader.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetCoverPageHeaderTID = parentTestId => getTestIds({
  parentTestId
});
export const CoverPageHeader = _ref => {
  let {
    testId,
    isDisabled,
    relationship
  } = _ref;
  const {
    CoverPageHeaderTestIds
  } = useMemo(() => GetCoverPageHeaderTID(testId), [testId]);
  const {
    showModal
  } = useOverlayContext();
  const {
    openNewTab
  } = useIoContext();
  const pdfHost = useStore(selectors.pdfHost);
  const onDownloadPdf = () => {
    openNewTab(getAgreementPdfUrl(relationshipModel.id(relationship), pdfHost));
  };
  const openInviteMemberModal = () => {
    showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(InviteOrEditMemberModal, {
          skin: "transparent",
          isResponsive: true,
          onClose: dismissModal
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(FullRow, {
    justifyContent: "end",
    testId: CoverPageHeaderTestIds.Root(),
    className: styles.root,
    children: /*#__PURE__*/_jsxs(Box, {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(TextButton, {
        testId: CoverPageHeaderTestIds.DownloadPdf(),
        prefixIcon: /*#__PURE__*/_jsx(Download, {}),
        underline: "none",
        onClick: onDownloadPdf,
        disabled: isDisabled,
        weight: "normal",
        children: "Download PDF"
      }), /*#__PURE__*/_jsx(Divider, {
        orientation: "vertical",
        margin: 16
      }), /*#__PURE__*/_jsx(TextButton, {
        testId: CoverPageHeaderTestIds.InviteMember(),
        prefixIcon: /*#__PURE__*/_jsx(UserAddLiner24, {}),
        underline: "none",
        disabled: isDisabled,
        onClick: openInviteMemberModal,
        weight: "normal",
        children: "Invite a team member"
      })]
    })
  });
};